module.exports = global["Hammer"] = require("-!/Volumes/Manfred/work/MEG-megacase/wp-content/themes/megacase/node_modules/babel-loader/lib/index.js??ref--0!./hammer.js");


//////////////////
// WEBPACK FOOTER
// ./node_modules/expose-loader?Hammer!./js/caseconfigurator/bin/hammer/hammer.js-exposed
// module id = 106
// module chunks = 0